class RichTextConfig extends BaseItemConfig {

    htmlText: KnockoutObservable<string>;

    constructor(data: any) {
        super(data);

        this.htmlText = ko.observable(data.htmlText);
    }

    get allowDetailTab(): boolean {
        return true;
    }

    createWorkbookTabLink(id: number, isWorkbook: boolean) {
        return `[Link ${id}${(isWorkbook ? "W" : "T")}]`
    }
}